import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import PrivacyPolicyDetails from "../components/PrivacyPolicyDetails";

const PrivacyPolicy = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Privacy Policy"} />

      {/* Service Details Area */}
      <PrivacyPolicyDetails />
      
      


      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default PrivacyPolicy;
